<template>
  <button
    class="btn-light-search search"
    :class="{ active: !openSearch }"
    @mouseover="handleMouseover({ id: 1 })"
    @mouseleave="handleMouseover({ reset: true })"
    @click="handleClickFilter({ type: 'search' })"
  >
    <div class="flex-center-vertical px-2">
      <div class="mr-1 mt-2px">
        <SearchLongIcon
          size="20"
          :color="dataColor.id === 1 && !openSearch ? dataColor.color : '#000'"
        />
      </div>
      <div v-if="openSearch" class="flex-center">
        <input
          v-model="keyword"
          ref="inputSearchProgress"
          type="number"
          class="input-search-progress"
          placeholder="Cari ID"
          @focus="onFocus"
          @blur="onBlur"
          @keyup="($event.key === 'Enter') && submitSearch()"
        />
        <div
          class="adjust-close-icon"
          @click="($event) => handleCloseFilter($event, { type: 'search' })"
        >
          <XMarkIcon color="#868686" size="12" />
        </div>
      </div>
      <p v-else class="color-grey">Pencarian</p>
    </div>
  </button>
</template>

<script>
export default {
  name: 'ButtonSearch',
  components: {
    SearchLongIcon: () => import('@/components/icons/SearchLongIcon'),
    XMarkIcon: () => import('@/components/icons/XMarkIcon')
  },
  props: {
    value: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      keyword: '',
      openSearch: false,
      dataColor: {
        id: null,
        color: '#868686'
      }
    }
  },
  methods: {
    onFocus () {
      this.$emit('focus')
    },
    onBlur () {
      if (!this.keyword) {
        this.openSearch = false
      }
    },
    handleMouseover (props) {
      const { id = null, reset = false } = props
      if (reset || !this.dataColor.id) {
        this.dataColor = {
          id: reset ? null : id,
          color: reset ? '#868686' : '#3185FC'
        }
      }
    },
    handleClickFilter (props) {
      const { type = null } = props
      if (this.openSearch) return

      if (type === 'search') {
        this.openSearch = !this.openSearch
        if (this.openSearch) {
          this.$nextTick(() => {
            this.$refs.inputSearchProgress.focus()
          })
        }
      }
    },
    handleCloseFilter (e, props) {
      e.stopPropagation()

      const { type = null } = props
      if (type === 'search') {
        this.keyword = ''
        this.openSearch = false
      }
      this.$emit('clear')
    },
    submitSearch () {
      this.$emit('submit', this.keyword)
    }
  },
  mounted () {
    if (this.value) {
      this.openSearch = true
      this.keyword = this.value
    }
  },
  watch: {
    keyword (value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-light-search {
  border-radius: 8px;
  border: 1px solid #CBD5E1;
  padding: 3px 7px;
  padding-left: 0;
  background: white;
  transition: background 0.15s ease-in-out, border-color 0.15s ease-in-out, width 0.2s ease-in-out;
  cursor: pointer;

  &:hover {
    background: #e1eeff;
    border-color: #3185fc;

    p {
      color: #3185fc !important;
    }
  }

  &.search.active {
    width: 115px;
  }

  &.search {
    width: 185px;
    height: 33px;
  }
}

.input-search-progress {
  border: none;
  outline: none;
  width: 90%;
}

.adjust-close-icon {
  transform: translate(5px, 1px);
}
</style>
